// extracted by css-extract-rspack-plugin
export default {"expander":"Expander_expander__RS8_2","opened":"Expander_opened__iQYI_"};